import script from "./ModalDisclaimer.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDisclaimer.vue?vue&type=script&setup=true&lang=js"

import "./ModalDisclaimer.vue?vue&type=style&index=0&id=b9d3e032&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9d3e032"]])

export default __exports__